import script from "./AddAnNews.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAnNews.vue?vue&type=script&setup=true&lang=ts"

import "./AddAnNews.vue?vue&type=style&index=0&id=1ed75bb6&lang=css"

const __exports__ = script;

export default __exports__